import { CSSProperties, ReactNode } from 'react';
import { generatePath } from 'react-router';
import { Typography } from 'react-md';
import { ROUTES } from '@constants/routes';

export const TTI_REGIONS = ['us', 'cn1', 'cn2', 'vn', 'uk'];

export interface StartPageTileData {
    title: string;
    imgSrc: string;
    imgStyles?: CSSProperties;
    description: ReactNode;
    link: string;
}

const IMG_STYLES = { borderRadius: '5px' };

export const TTI_LOCATIONS = {
    [TTI_REGIONS[0]]: {
        country: 'USA',
        city: 'Charlotte',
        flag: '/img/start-page/tti/flag_01.png',
    },
    [TTI_REGIONS[1]]: {
        country: 'China',
        city: 'Suzhou',
        flag: '/img/start-page/tti/flag_02.png',
    },
    [TTI_REGIONS[2]]: {
        country: 'China',
        city: 'Dongguan',
        flag: '/img/start-page/tti/flag_02.png',
    },
    [TTI_REGIONS[3]]: {
        country: 'Vietnam',
        city: 'Dầu Giây',
        flag: '/img/start-page/tti/flag_03.png',
    },
    [TTI_REGIONS[4]]: {
        country: 'UK',
        city: 'Droitwich',
        flag: '/img/start-page/tti/flag_04.png',
    },
};

export const TTI_SELECT_REGION_TILES: StartPageTileData[] = [
    {
        title: TTI_LOCATIONS[TTI_REGIONS[0]].country,
        imgSrc: TTI_LOCATIONS[TTI_REGIONS[0]].flag,
        description: TTI_LOCATIONS[TTI_REGIONS[0]].city,
        link: generatePath(ROUTES.ttiTechnologySelectPage, { region: TTI_REGIONS[0] }),
        imgStyles: IMG_STYLES,
    },
    {
        title: TTI_LOCATIONS[TTI_REGIONS[1]].country,
        imgSrc: TTI_LOCATIONS[TTI_REGIONS[1]].flag,
        description: TTI_LOCATIONS[TTI_REGIONS[1]].city,
        link: generatePath(ROUTES.ttiTechnologySelectPage, { region: TTI_REGIONS[1] }),
        imgStyles: IMG_STYLES,
    },
    {
        title: TTI_LOCATIONS[TTI_REGIONS[2]].country,
        imgSrc: TTI_LOCATIONS[TTI_REGIONS[2]].flag,
        description: TTI_LOCATIONS[TTI_REGIONS[2]].city,
        link: generatePath(ROUTES.ttiTechnologySelectPage, { region: TTI_REGIONS[2] }),
        imgStyles: IMG_STYLES,
    },
    {
        title: TTI_LOCATIONS[TTI_REGIONS[3]].country,
        imgSrc: TTI_LOCATIONS[TTI_REGIONS[3]].flag,
        description: TTI_LOCATIONS[TTI_REGIONS[3]].city,
        link: generatePath(ROUTES.ttiTechnologySelectPage, { region: TTI_REGIONS[3] }),
        imgStyles: IMG_STYLES,
    },
    {
        title: TTI_LOCATIONS[TTI_REGIONS[4]].country,
        imgSrc: TTI_LOCATIONS[TTI_REGIONS[4]].flag,
        description: TTI_LOCATIONS[TTI_REGIONS[4]].city,
        link: generatePath(ROUTES.ttiTechnologySelectPage, { region: TTI_REGIONS[4] }),
        imgStyles: IMG_STYLES,
    },
];

export const TTI_SELECT_LOCATION_TILES: { [key: (typeof TTI_REGIONS)[number]]: StartPageTileData[] } = {
    [TTI_REGIONS[0]]: [
        {
            title: 'MJF',
            imgSrc: '/img/start-page/tti/tech_01.png',
            description: (
                <div>
                    <Typography>15 x 11 x 15 in</Typography>
                    <Typography>(380 x 284 x 380 mm)</Typography>
                </div>
            ),
            link: 'https://app.digifabster.com/tti-floor-care-mjf/widget/upload',
        },
        {
            title: 'FDM',
            imgSrc: '/img/start-page/tti/tech_02.png',
            description: (
                <div>
                    <Typography>16 x 14 x 16 in</Typography>
                    <Typography>(406 x 355 x 406 mm)</Typography>
                </div>
            ),
            link: 'https://app.digifabster.com/tti-floor-care-fdm/widget/upload',
        },
        {
            title: 'SLA',
            imgSrc: '/img/start-page/tti/tech_03.png',
            description: (
                <div>
                    <Typography>13.2 x 7.9 x 11.2 in</Typography>
                    <Typography>(335 x 200 x 300 mm)</Typography>
                </div>
            ),
            link: 'https://app.digifabster.com/tti-floor-care-sla/widget/upload',
        },
        {
            title: 'Vacuum Casting',
            imgSrc: '/img/start-page/tti/tech_04.png',
            description: (
                <div>
                    <Typography>Molds and Final</Typography>
                    <Typography>Geometry Required</Typography>
                </div>
            ),
            link: 'https://app.digifabster.com/tti-floor-care-vacuum-casting/widget/upload',
        },
        {
            title: 'CO2 Laser',
            imgSrc: '/img/start-page/tti/tech_05.png',
            description: (
                <div>
                    <Typography>24 x 40 in</Typography>
                    <Typography>(609 x 1016 mm)</Typography>
                </div>
            ),
            link: 'https://app.digifabster.com/tti-floor-care-co2-laser/widget/upload',
        },
        {
            title: '3D Scanner',
            imgSrc: '/img/start-page/tti/tech_06.png',
            description: (
                <div>
                    <Typography>Accurate, Reliable</Typography>
                    <Typography>& High-Resolution</Typography>
                </div>
            ),
            link: 'https://app.digifabster.com/tti-floor-care-3d-scanner/widget/upload',
        },
        {
            title: 'Tufting',
            imgSrc: '/img/start-page/tti/tech_07.png',
            description: (
                <div>
                    <Typography>Creating rugs by punching yarn</Typography>
                    <Typography>through fabric to form patterns</Typography>
                </div>
            ),
            link: 'https://app.digifabster.com/tti-floor-care-tufting/widget/upload/',
        },
        {
            title: 'Custom Painting',
            imgSrc: '/img/start-page/tti/tech_08.png',
            description: (
                <div>
                    <Typography>CMF document Required</Typography>
                    <Typography>if more then one color</Typography>
                </div>
            ),
            link: 'https://app.digifabster.com/tti-floor-care-custom-painting/widget/upload',
        },
    ],
    [TTI_REGIONS[1]]: [
        {
            title: 'FDM',
            imgSrc: '/img/start-page/tti/tech_02.png',
            description: (
                <div>
                    <Typography>16 x 14 x 16 in</Typography>
                    <Typography>(406 x 355 x 406 mm)</Typography>
                </div>
            ),
            link: 'https://app.digifabster.com/tti-floor-care-suzhou-fdm/widget/upload/',
        },
    ],
    [TTI_REGIONS[2]]: [
        {
            title: 'FDM',
            imgSrc: '/img/start-page/tti/tech_02.png',
            description: (
                <div>
                    <Typography>16 x 14 x 16 in</Typography>
                    <Typography>(406 x 355 x 406 mm)</Typography>
                </div>
            ),
            link: 'https://app.digifabster.com/tti-floor-care-dongguan-fdm/widget/upload/',
        },
    ],
    [TTI_REGIONS[3]]: [
        {
            title: 'FDM',
            imgSrc: '/img/start-page/tti/tech_02.png',
            description: (
                <div>
                    <Typography>16 x 14 x 16 in</Typography>
                    <Typography>(406 x 355 x 406 mm)</Typography>
                </div>
            ),
            link: 'https://app.digifabster.com/tti-floor-care-dau-giay-fdm/widget/upload/',
        },
    ],
    [TTI_REGIONS[4]]: [
        {
            title: 'FDM',
            imgSrc: '/img/start-page/tti/tech_02.png',
            description: (
                <div>
                    <Typography>16 x 14 x 16 in</Typography>
                    <Typography>(406 x 355 x 406 mm)</Typography>
                </div>
            ),
            link: 'https://app.digifabster.com/tti-floor-care-droitwich-fdm/widget/upload/',
        },
        {
            title: 'SLA',
            imgSrc: '/img/start-page/tti/tech_03.png',
            description: (
                <div>
                    <Typography>13.2 x 7.9 x 11.2 in</Typography>
                    <Typography>(335 x 200 x 300 mm)</Typography>
                </div>
            ),
            link: 'https://app.digifabster.com/tti-floor-care-droitwich-sla/widget/upload/',
        },
    ],
};

interface StartPageInfo {
    title: string;
    description?: string;
}

export const TTI_SELECT_REGION_INFO: StartPageInfo = {
    title: 'Select shop location',
};

export const TTI_SELECT_LOCATION_INFO: StartPageInfo = {
    title: 'Choose technology',
    description: `Please choose the technology that best fits your order's needs.
    Orders are limited to a single technology. If you have any questions about
    technology selection, feel free to reach out to one of the Model Shop members.
    We'd be happy to help.`,
};
